// db-mousepad-size.js

let padPreviewQueue = [];
let sizeModalEscHandler;
let deskWidthMM = 1200;
let deskDepthMM = 600;
const monitorWidthMM = 571;
const keyboardWidthMM = 450;

function openPadSizePreviewModal() {
  const modal = document.getElementById("padSizePreviewModal");
  if (!modal) return;
  modal.style.display = "flex";
  modal.style.opacity = "1";
  modal.style.visibility = "visible";
  modal.style.zIndex = "9999";

  updateCanvasSize();
  renderAllPads();

  const wrapper = document.getElementById("padSizeCanvasWrapper");
  const maxDims = padPreviewQueue.reduce(
    (acc, p) => {
      const d = getDimsFromTags(p.tags) || [0, 0];
      return [Math.max(acc[0], d[0]), Math.max(acc[1], d[1])];
    },
    [deskWidthMM, deskDepthMM]
  );
  const scaleX = wrapper.clientWidth / maxDims[0];
  const scaleY = wrapper.clientHeight / maxDims[1];

  const fixedMonitor = document.getElementById("desk-monitor");
  const fixedKeyboard = document.getElementById("desk-keyboard");

  if (fixedMonitor) {
    fixedMonitor.style.width = `${monitorWidthMM * scaleX}px`;
  }
  if (fixedKeyboard) {
    fixedKeyboard.style.width = `${keyboardWidthMM * scaleX}px`;
  }

  const monitor = document.getElementById("desk-monitor");
  const keyboard = document.getElementById("desk-keyboard");
  if (monitor && keyboard) {
    makeCloneOnDrag(monitor, wrapper);
    makeCloneOnDrag(keyboard, wrapper);
  }

  const mouse = document.getElementById("desk-mouse");
  if (mouse) {
    mouse.style.display = "block";
    mouse.style.width = `${63 * scaleX}px`;
    makeCloneOnDrag(mouse, wrapper);
  }

  renderPadPreviewList();
  updateResetPadsButtonState();
  updateResetAccessoriesButtonState();
}

function makePadDraggable(pad, product) {
  let isDragging = false;
  let startX = 0, startY = 0;
  let origLeft = 0, origBottom = 0;
  let animationFrameId;

  const onDrag = (e) => {
    if (!isDragging) return;

    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    const newLeft = origLeft + dx;
    const newBottom = origBottom - dy;

    // Cancel any queued frame and queue new one
    if (animationFrameId) cancelAnimationFrame(animationFrameId);
    animationFrameId = requestAnimationFrame(() => {
      pad.style.left = `${newLeft}px`;
      pad.style.bottom = `${newBottom}px`;

      // Store current position
      product._padX = newLeft;
      product._padY = newBottom;
    });
  };

  const onStop = () => {
    isDragging = false;
    document.removeEventListener("mousemove", onDrag);
    document.removeEventListener("mouseup", onStop);
    if (animationFrameId) cancelAnimationFrame(animationFrameId);
  };

  pad.addEventListener("mousedown", (e) => {
    isDragging = true;
    startX = e.clientX;
    startY = e.clientY;
    origLeft = parseFloat(pad.style.left);
    origBottom = parseFloat(pad.style.bottom);
    document.addEventListener("mousemove", onDrag);
    document.addEventListener("mouseup", onStop);
    e.preventDefault();
  });
}

function makeElementDraggable(el, container) {
  let isDragging = false;
  let startX = 0,
    startY = 0;
  let origLeft = 0,
    origTop = 0;

  el.addEventListener("mousedown", (e) => {
    isDragging = true;
    startX = e.clientX;
    startY = e.clientY;
    origLeft = parseFloat(el.style.left) || 0;
    origTop = parseFloat(el.style.top) || 0;
    container.addEventListener("mousemove", onMouseMove);
    container.addEventListener("mouseup", onMouseUp);
    e.preventDefault();
  });

  function onMouseMove(e) {
    if (!isDragging) return;
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    el.style.left = `${origLeft + dx}px`;
    el.style.top = `${origTop + dy}px`;
  }

  function onMouseUp() {
    isDragging = false;
    container.removeEventListener("mousemove", onMouseMove);
    container.removeEventListener("mouseup", onMouseUp);
  }
}

function updateCanvasSize() {
  const wrapper = document.getElementById("padSizeCanvasWrapper");
  const outer = document.getElementById("padSizeOuterWrapper");

  const maxPadDims = padPreviewQueue.reduce(
    (acc, p) => {
      const dims = getDimsFromTags(p.tags);
      if (!dims) return acc;
      return [Math.max(acc[0], dims[0]), Math.max(acc[1], dims[1])];
    },
    [0, 0]
  );

  const canvasWidthMM = Math.max(deskWidthMM, maxPadDims[0]);
  const canvasDepthMM = Math.max(deskDepthMM, maxPadDims[1]);

  const scale = 0.4;

  wrapper.style.width = `${canvasWidthMM * scale}px`;
  wrapper.style.height = `${canvasDepthMM * scale}px`;
  wrapper.style.background = "transparent";

  outer.style.width = `${Math.max(canvasWidthMM * scale + 40, 760)}px`;
}

function addPadToPreview(product) {
  if (padPreviewQueue.length >= 4) {
    console.warn("You can only preview up to 4 pads");
    return;
  }

  if (!padPreviewQueue.find((p) => p.id === product.id)) {
    padPreviewQueue.push(product);
  }
  updateCanvasSize();
  renderAllPads();
  renderPadPreviewList();
  updateResetPadsButtonState();
}

function renderPadPreviewList() {
  const listContainer = document.getElementById("padPreviewList");
  if (!listContainer) return;
  listContainer.innerHTML = "";

  const colors = ["#90caf9", "#ffe082", "#a5d6a7", "#f48fb1", "#ce93d8"];

  padPreviewQueue.forEach((product, index) => {
    const bg = colors[index % colors.length];
    const fg = getContrastColor(bg);

    const item = document.createElement("div");
    item.className = "pad-list-item";
    item.style.marginBottom = "5px";
    item.style.background = bg;
    item.style.color = fg;
    item.style.padding = "2px 10px";
    item.style.borderRadius = "5px";
    item.innerHTML = `
      <span>${product.title}</span>
      <button class="remove-pad-btn" data-index="${index}" style="margin-left: 8px; background: transparent; border: none; color: ${fg}; cursor: pointer;">x</button>
    `;
    listContainer.appendChild(item);
  });

  document.querySelectorAll(".remove-pad-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const index = parseInt(e.target.dataset.index);
      padPreviewQueue.splice(index, 1);
      updateCanvasSize();
      renderAllPads();
      renderPadPreviewList();
      updateResetPadsButtonState();
    });
  });
}

function renderAllPads() {
  const wrapper = document.getElementById("padSizeCanvasWrapper");
  wrapper
    .querySelectorAll(".pad-outline, .pad-dims-label, .desk-outline")
    .forEach((el) => el.remove());
  wrapper
    .querySelectorAll(".desk-label, .desk-arrow")
    .forEach((el) => el.remove());

  const maxWidth = Math.max(
    deskWidthMM,
    ...padPreviewQueue.map((p) => getDimsFromTags(p.tags)?.[0] || 0)
  );
  const maxDepth = Math.max(
    deskDepthMM,
    ...padPreviewQueue.map((p) => getDimsFromTags(p.tags)?.[1] || 0)
  );

  const scaleX = wrapper.clientWidth / maxWidth;
  const scaleY = wrapper.clientHeight / maxDepth;

  const desk = document.createElement("div");
  desk.className = "desk-outline";
  desk.style.position = "absolute";
  desk.style.width = `${deskWidthMM * scaleX}px`;
  desk.style.height = `${deskDepthMM * scaleY}px`;
  desk.style.left = `${(wrapper.clientWidth - deskWidthMM * scaleX) / 2}px`;
  desk.style.bottom = `0px`;
  desk.style.background = "#ddd";
  desk.style.border = "2px solid #666";
  desk.style.zIndex = "0";
  desk.style.borderRadius = "10px";
  wrapper.appendChild(desk);

  const deskLabel = document.createElement("div");
  deskLabel.className = "desk-label";
  deskLabel.textContent = "Your Desk";
  Object.assign(deskLabel.style, {
    position: "absolute",
    left: `${
      (wrapper.clientWidth - deskWidthMM * scaleX) / 2 +
      (deskWidthMM * scaleX) / 2
    }px`,
    bottom: `${deskDepthMM * scaleY + 6}px`,
    transform: "translateX(-50%)",
    background: "#000",
    color: "#fff",
    padding: "2px 6px",
    borderRadius: "4px",
    fontSize: "11px",
    whiteSpace: "nowrap",
    zIndex: 100,
  });
  wrapper.appendChild(deskLabel);

  const arrow = document.createElement("div");
  arrow.className = "desk-arrow";
  Object.assign(arrow.style, {
    position: "absolute",
    left: `${
      (wrapper.clientWidth - deskWidthMM * scaleX) / 2 +
      (deskWidthMM * scaleX) / 2 -
      5
    }px`,
    bottom: `${deskDepthMM * scaleY}px`,
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "6px solid #000",
    zIndex: 99,
  });
  wrapper.appendChild(arrow);

  const colors = ["#90caf9", "#ffe082", "#a5d6a7", "#f48fb1", "#ce93d8"];
  padPreviewQueue.forEach((product, index) => {
    const dims = getDimsFromTags(product.tags);
    if (!dims) return;
    const [width, length] = dims;

    const padWpx = width * scaleX;
    const padHpx = length * scaleY;
    const padColor = colors[index % colors.length];
    const padTextColor = getContrastColor(padColor);

    const leftOffset = (wrapper.clientWidth - deskWidthMM * scaleX) / 2;

    const pad = document.createElement("div");
    pad.className = "pad-outline";
    pad.style.position = "absolute";
    pad.style.width = `${padWpx}px`;
    pad.style.height = `${padHpx}px`;
    pad.style.left = typeof product._padX === "number"
      ? `${product._padX}px`
      : `${leftOffset + (deskWidthMM * scaleX - padWpx)}px`; // align right side
    
    pad.style.bottom = typeof product._padY === "number"
      ? `${product._padY}px`
      : `0px`; // stick to bottom edge
    pad.style.background = padColor;
    pad.style.opacity = "0.4";
    pad.style.border = "1px solid #000";
    pad.style.zIndex = `${index + 1}`;
    wrapper.appendChild(pad);
    makePadDraggable(pad, product);

    const LABEL_OFFSET = 8;
    const labelOffsetMultiplier = index * 16;

    const widthLabel = document.createElement("div");
    widthLabel.className = "pad-label width-label";
    widthLabel.textContent = `${width} mm`;
    Object.assign(widthLabel.style, {
      position: "absolute",
      top: "-16px",
      left: `${index * 58}px`, // spreads horizontally
      padding: "4px 6px",
      lineHeight: "1",
      background: padColor,
      color: padTextColor,
      fontSize: "11px",
      fontWeight: "bold",
      borderRadius: "4px",
      whiteSpace: "nowrap",
      zIndex: index + 2,
    });
    pad.appendChild(widthLabel);
    
    const lengthLabel = document.createElement("div");
    lengthLabel.className = "pad-label length-label";
    lengthLabel.textContent = `${length} mm`;
    Object.assign(lengthLabel.style, {
      position: "absolute",
      left: "100%",
      top: `${index * 24}px`, // stacks vertically
      marginLeft: "8px",
      padding: "4px 6px",
      lineHeight: "1",
      height: "max-content",    
      background: padColor,
      color: padTextColor,
      fontSize: "11px",
      fontWeight: "bold",
      borderRadius: "4px",
      whiteSpace: "nowrap",
      zIndex: index + 2,
    });
    pad.appendChild(lengthLabel);
  });
}

function getDimsFromTags(tags) {
  const dimsTag = tags.find((t) => t.startsWith("Dims__"));
  if (!dimsTag) return null;
  const parts = dimsTag.replace("Dims__", "").replace(/mm/gi, "").split(/[x×]/);
  if (parts.length < 2) return null;
  const [w, l] = parts.map((v) => parseFloat(v.trim()));
  return isNaN(w) || isNaN(l) ? null : [w, l];
}

function getContrastColor(hex) {
  const rgb = hex
    .replace("#", "")
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16));
  const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
  return brightness > 140 ? "#000" : "#fff";
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .getElementById("openPadPreviewModalLink")
    ?.addEventListener("click", (e) => {
      e.preventDefault();
      openPadSizePreviewModal();

      const sizeModal = document.getElementById("padSizePreviewModal");
      sizeModal.setAttribute("aria-modal", "true");
      sizeModal.setAttribute("role", "dialog");
      sizeModal.setAttribute("tabindex", "-1");
      sizeModal.focus();

      sizeModalEscHandler = (e) => {
        if (e.key === "Escape") {
          closeModal("padSizePreviewModal");
          document.removeEventListener("keydown", sizeModalEscHandler);
          sizeModalEscHandler = null;
        }
      };
      document.addEventListener("keydown", sizeModalEscHandler);
    });

  document
    .getElementById("padSizePreviewCloseBtn")
    ?.addEventListener("click", () => {
      document.getElementById("padSizePreviewModal").style.display = "none";
    });

document.getElementById("resetClonesBtn")?.addEventListener("click", () => {
  const wrapper = document.getElementById("padSizeCanvasWrapper");
  const accessories = wrapper?.querySelectorAll(
    "img:not(#desk-monitor):not(#desk-keyboard)"
  );

  if (!accessories.length) return;

  showConfirmModal("Remove all accessories?", (confirmed) => {
    if (!confirmed) return;
  
    accessories.forEach((el) => el.remove());
    updateResetAccessoriesButtonState();
  });
});

const resetPadsBtn = document.getElementById("resetPadsBtn");

if (resetPadsBtn) {
  resetPadsBtn.addEventListener("click", () => {
    if (padPreviewQueue.length === 0) return;

    showConfirmModal("Remove all mousepads?", (confirmed) => {
      if (!confirmed) return;
    
      padPreviewQueue = [];
      updateCanvasSize();
      renderAllPads();
      renderPadPreviewList();
      updateResetPadsButtonState();
    });

  });
}

  if (sizeModalEscHandler) {
    document.removeEventListener("keydown", sizeModalEscHandler);
    sizeModalEscHandler = null;
  }

  const wrapper = document.getElementById("padSizeCanvasWrapper");
  if (wrapper) {
    wrapper.addEventListener("dragover", (e) => {
      e.preventDefault();
      wrapper.style.border = "2px dashed #fb0440";
    });

    wrapper.addEventListener("dragleave", () => {
      wrapper.style.border = "";
    });

    wrapper.addEventListener("drop", (e) => {
      e.preventDefault();
      wrapper.style.border = "";
      const productIds = e.dataTransfer.getData("text/plain").split(",");
      productIds.forEach((id) => {
        const product = window.allProducts?.find(
          (p) => p.id === id.trim() || p.handle === id.trim()
        );
        if (product) {
          addPadToPreview(product);
        } else {
          console.warn("❌ Dropped product not found for ID:", id);
        }
      });
      updateResetAccessoriesButtonState();
    });
  }

  const widthInput = document.getElementById("deskWidthInput");
  const depthInput = document.getElementById("deskDepthInput");

  if (widthInput && depthInput) {
    const onResize = () => {
      let widthVal = parseInt(widthInput.value) || 1200;
      let depthVal = parseInt(depthInput.value) || 600;

      if (widthVal > 1800) {
        widthVal = 1800;
        showDeskLimitWarning("Width cannot exceed 1800 mm");
      } else if (widthVal < 500) {
        widthVal = 500;
        showDeskLimitWarning("Width cannot be less than 500 mm");
      }

      if (depthVal > 1000) {
        depthVal = 1000;
        showDeskLimitWarning("Depth cannot exceed 1000 mm");
      } else if (depthVal < 300) {
        depthVal = 300;
        showDeskLimitWarning("Depth cannot be less than 300 mm");
      }

      deskWidthMM = widthVal;
      deskDepthMM = depthVal;
      widthInput.value = widthVal;
      depthInput.value = depthVal;

      updateCanvasSize();
      renderAllPads();
    };
    widthInput.addEventListener("change", onResize);
    depthInput.addEventListener("change", onResize);
  }

  document.querySelectorAll("tr[data-product-id]").forEach((row) => {
    row.addEventListener("dragstart", (e) => {
      const productId = row.getAttribute("data-product-id");
      if (productId) e.dataTransfer.setData("text/plain", productId);

      const dragPreview = document.createElement("div");
      dragPreview.style.position = "absolute";
      dragPreview.style.top = "-9999px";
      dragPreview.style.padding = "4px 10px";
      dragPreview.style.background = "#222";
      dragPreview.style.color = "#fff";
      dragPreview.style.fontSize = "12px";
      dragPreview.style.borderRadius = "4px";
      dragPreview.innerText =
        row.querySelector("td:nth-child(6)")?.innerText || "Product";
      document.body.appendChild(dragPreview);
      e.dataTransfer.setDragImage(dragPreview, 0, 0);

      setTimeout(() => dragPreview.remove(), 0);
    });
  });
});

document
  .getElementById("padSearchInput")
  ?.addEventListener("input", function () {
    const resultsContainer = document.getElementById("padSearchResults");
    resultsContainer.innerHTML = "";
    resultsContainer.style.display = "block";
    const term = this.value.trim().toLowerCase();
    if (!term || !Array.isArray(window.allProducts)) return;

    const matches = window.allProducts
      .filter(
        (p) =>
          p.title.toLowerCase().includes(term) ||
          p.vendor?.toLowerCase().includes(term)
      )
      .slice(0, 10);

    matches.forEach((product) => {
      const div = document.createElement("div");
      div.className = "result-item";
      div.textContent = product.title;
      div.addEventListener("click", () => {
        addPadToPreview(product);
        updateResetPadsButtonState();
        document.getElementById("padSearchInput").value = "";
        resultsContainer.innerHTML = "";
        resultsContainer.style.display = "none";
      });
      resultsContainer.appendChild(div);
    });
  });

function makeCloneOnDrag(sourceEl, container) {
  let isHeld = false;
  let holdTimer = null;

  sourceEl.addEventListener("mousedown", (e) => {
    e.preventDefault();

    holdTimer = setTimeout(() => {
      isHeld = true;

      const rect = sourceEl.getBoundingClientRect();
      const clone = sourceEl.cloneNode(true);
      clone.removeAttribute("id");
      clone.style.position = "absolute";
      clone.style.cursor = "move";
      clone.style.left = `${
        rect.left + window.scrollX - container.getBoundingClientRect().left
      }px`;
      clone.style.top = `${
        rect.top + window.scrollY - container.getBoundingClientRect().top
      }px`;
      clone.style.zIndex = "200";
      container.appendChild(clone);

      let offsetX = e.clientX - rect.left;
      let offsetY = e.clientY - rect.top;

      function onMouseMove(ev) {
        clone.style.left = `${
          ev.clientX - offsetX - container.getBoundingClientRect().left
        }px`;
        clone.style.top = `${
          ev.clientY - offsetY - container.getBoundingClientRect().top
        }px`;
      }

      function onMouseUp() {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        makeElementDraggable(clone, container);
        updateResetAccessoriesButtonState();
      }

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }, 50);
  });

  sourceEl.addEventListener("mouseup", () => {
    clearTimeout(holdTimer);
    isHeld = false;
  });

  sourceEl.addEventListener("mouseleave", () => {
    clearTimeout(holdTimer);
    isHeld = false;
  });
}

function showDeskLimitWarning(msg) {
  let warning = document.getElementById("deskLimitNotice");
  const inputContainer =
    document.getElementById("deskSizeInputWrapper") || document.body;

  if (!warning) {
    warning = document.createElement("div");
    warning.id = "deskLimitNotice";
    Object.assign(warning.style, {
      display: "inline-block",
      marginLeft: "12px",
      color: "#fb0440",
      fontSize: "13px",
      fontWeight: "bold",
    });
    inputContainer.appendChild(warning);
  }

  warning.textContent = msg;
  clearTimeout(warning._hideTimer);
  warning._hideTimer = setTimeout(() => warning.remove(), 2500);
}

function updateResetPadsButtonState() {
  const btn = document.getElementById("resetPadsBtn");
  if (!btn) return;

  if (padPreviewQueue.length === 0) {
    btn.style.display = "none";
  } else {
    btn.style.display = "inline-block";
  }
}

function updateResetAccessoriesButtonState() {
  const btn = document.getElementById("resetClonesBtn");
  if (!btn) return;

  const wrapper = document.getElementById("padSizeCanvasWrapper");
  const accessories = wrapper?.querySelectorAll(
    "img:not(#desk-monitor):not(#desk-keyboard)"
  );

  if (!accessories || accessories.length === 0) {
    btn.style.display = "none";
  } else {
    btn.style.display = "inline-block";
  }
}
